import { render, staticRenderFns } from "./SliderCareer.vue?vue&type=template&id=aed38496&"
import script from "./SliderCareer.vue?vue&type=script&lang=js&"
export * from "./SliderCareer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports